
import { Link } from "react-router-dom";
import { validateForm, removeMsg, showAlertMsg, isValidEmail, ButtonSpinner } from "../../components/CommonMethod";
import { trim } from "lodash";

function UserInfoCard({ data, setData, show, goto, loading }) {

    const handleInputChange = (e) => setData({ ...data, [e.target.name]: e.target.value })

    const submitBillerDetailsForm = (e) => {
        if (validateForm(e, 'billerDetailsForm')) {
            removeMsg()
            if (trim(data.biller_first_name) && trim(data.biller_last_name) && isValidEmail(trim(data.biller_email))) {
                goto(true);
            } else {
                showAlertMsg({ error: "Please fill an valid data" });
            }
        }
    }

    return <>
        <div className="rounded-2 border border-2 border-blue p-4 my-3">
            <div className="col-sm-12 d-flex">
                <div className="account d-flex ">
                    <h4 className="rounded-circle border border-blue text-blue text-center fs-24 px-2" style={{ height: '30px', width: '30px' }}>1</h4><h4 className=" fw-bold fs-24  text-blue ms-2">Biller details</h4>
                </div>
                <div className="ms-auto">
                    {!show && <button type="button" className="btn mmwh-48 d-inline-flex justify-content-center align-items-center" title="Edit" onClick={() => goto(false)}>
                        <svg className="icon ts-1p5"><use href="#icon_pencil"></use></svg>
                    </button>}
                </div>
            </div>

            {show &&
                <form className="needs-validation" method="post" id="billerDetailsForm" noValidate autoComplete="off">
                    <div className="row py-2">
                        <p className="py-2">If you are under 18 this purchase will be billed to your nominated parent or guardian.</p>

                        <div className="col-sm-6 mb-2">
                            <div className='form-floating'>
                                <input type='text' id="biller_first_name" name="biller_first_name" placeholder="Biller First name" className="form-control form-control-md" value={data.biller_first_name} onChange={handleInputChange} required />
                                <div className="invalid-feedback">The biller first name field is required.</div>
                                <label>Biller first name <span className="text-danger">*</span></label>
                            </div>
                        </div>
                        <div className="col-sm-6 mb-2 mt-check">
                            <div className='form-floating'>
                                <input type='text' id="biller_last_name" name="biller_last_name" placeholder="Biller Last name" className="form-control form-control-md" value={data.biller_last_name} onChange={handleInputChange} required />
                                <div className="invalid-feedback">The biller last name field is required.</div>
                                <label>Biller last name <span className="text-danger">*</span></label>
                            </div>
                        </div>

                        <div className="col-sm-7 mt-3 mb-2">
                            <div className='form-floating'>
                                <input type='email' id="biller_email" name="biller_email" placeholder="Biller Email" className="form-control form-control-md" value={data.biller_email} onChange={handleInputChange} required />
                                <div className="invalid-feedback">The email field is required and must be a valid email address.</div>
                                <label>Biller Email <span className="text-danger">*</span></label>
                            </div>
                        </div>

                        <div className="col-sm-7 mt-3 mb-2">
                            <div className="checkbox_agree_condition py-3 mt-1">
                                <label className="form-check form-check-custom d-inline-block">
                                    <input className="form-check-input" name="age_group" type="checkbox" checked={data.under_18} id="age_group" onChange={(e) => setData({ ...data, under_18: e.target.checked })} />
                                    <div className="form-check-label fw-bold">Is the user under 18 years old?</div>
                                </label>
                            </div>
                        </div>

                        <div className="col-sm-7 mt-3 mb-2">
                            <div className="checkbox_agree_condition mb-4 ">
                                <label className="form-check form-check-custom ">
                                    <input className="form-check-input privacy-check" type="checkbox" checked={data.accept_terms} id="age_group" onChange={(e) => setData({ ...data, accept_terms: e.target.checked })} required />
                                    <div className="form-check-label fw-bold privacy-check">I agree with We are all Elemental's
                                        <Link to="/terms-of-use" target="_blank" className="ps-1">Terms of use</Link> and <Link to="/privacy-policy" target="_blank" className="ps-1">Privacy policy</Link></div>
                                    <div className="invalid-feedback position-absolute">
                                        You must agree before submitting.
                                    </div>
                                </label>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12 py-3 d-flex justify-content-end">
                                <button type="button" disabled={loading} className="btn btn-theme-primary minw-90 me-3" onClick={submitBillerDetailsForm}>
                                    <ButtonSpinner load={loading} btnName="Next" />
                                </button>
                            </div>
                        </div>

                    </div>
                </form>}

            {!show && <><div className="row">
                <div className="col-sm-12">
                    <div className="row py-2 ps-5">
                        <div className="col-sm-6 fw-bold">FIRST NAME:</div>
                        <div className="col-sm-6">{data.biller_first_name}</div>
                    </div>
                    <div className="row py-2 ps-5">
                        <div className="col-sm-6 fw-bold">LAST NAME:</div>
                        <div className="col-sm-6">{data.biller_last_name}</div>
                    </div>
                    <div className="row py-2 ps-5">
                        <div className="col-sm-6 fw-bold">EMAIL:</div>
                        <div className="col-sm-6">{data.biller_email}</div>
                    </div>
                </div>
            </div>
            </>}
        </div>
    </>
}
export default UserInfoCard
